import React from "react";
import {Link} from "react-router-dom";

class Logo extends React.Component {
    constructor(props){
        super(props);
    }
    render() {
        return(
            <>
                <div className="topbar-left">
                    <Link to="/" className="logo">
                            <span>
                                <img src="/assets/images/logo.png" alt="logo-small" className="logo-sm" />
                                <span className={"ml-1 font-25 text-logo"}>
                                    <span>{this.props.brand}</span>
                                </span>
                            </span>
                    </Link>
                </div>
            </>
        );
    }
}

export default Logo;